export default __webpack_public_path__ + "static/media/003-frontal-view.02e2ba43.png";